import { Injectable } from "@angular/core";
import { Address } from "@app/address/model/address";
import { Observable, of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { ClareHomeRPCMethodNames, ClareHomeRPCServiceNames, PROJECT_INFO_METHODS } from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";

export enum ProjectInfoKeys {
    timezone = "com.clarecontrols.equator.project.info.timezone",
    coordinates = "com.clarecontrols.equator.project.info.coordinates",
}

@Injectable({
    providedIn: "root",
})
export class EquatorProjectinfoService {
    constructor(readonly equatorProxyService: EquatorProxyService) {}

    private call(uuid: string, method: ClareHomeRPCMethodNames, params: any[]) {
        return this.equatorProxyService.makeClareHomeRpcRequest$(
            uuid, // uuid
            ClareHomeRPCServiceNames.PROJECT_INFO, // service
            method, // method
            params // params
        );
    }

    public getConfiguration(uuid: string) {
        return this.call(uuid, PROJECT_INFO_METHODS.GET_CONFIGURATION, []);
    }

    public setConfiguration(uuid: string, config) {
        return this.call(uuid, PROJECT_INFO_METHODS.SET_CONFIGURATION, [config]);
    }

    public getTimezone(uuid: string) {
        return this.getConfiguration(uuid).pipe(map(result => result?.[ProjectInfoKeys.timezone] || ""));
    }

    public sendCoordinates(uuid: string, address: Address): Observable<boolean> {
        return this.getConfiguration(uuid).pipe(
            exhaustMap(result => {
                result[ProjectInfoKeys.coordinates] = address.coordinates;
                result[ProjectInfoKeys.timezone] = address.timezoneid;

                return this.setConfiguration(uuid, result).pipe(map(_ => true));
            }),
            catchError(_ =>
                // return false for now. expand handler as error messages expand
                of(false)
            )
        );
    }
}
